<template>
  <div class="homepage-grid-line-container">
    <div class="items-container">
      <div class="row line-items" v-if="this.lineItems">
        <homepage-grid-button v-for="item in this.lineItems" :key="item.id"
          :iconClass="getIconClass(item)"
          :text="getText(item)"
          :route="getRoute(item)"
          :idService="getIdService(item)"
          :isHidden="getIsHidden(item)"
          :enabled="getEnabled(item)">
        </homepage-grid-button>
      </div>
    </div>
  </div>
</template>

<script>
  import homepageGridButton from '@/components/Homepage/homepageGridButton.vue'
  export default {
    name: 'homepageGridLine',
    components: {
      'homepage-grid-button': homepageGridButton
    },
    props: ['lineData'],
    data () {
      return {
        lineTitle: '',
        lineItems: []
      }
    },
    created () {
      this.lineTitle = this.lineData && this.lineData.title ? this.lineData.title : 'default title'
      this.lineItems = this.lineData && this.lineData.items ? this.lineData.items : []

      let lineItems = this.lineItems
      let that = this
      this.$bus.$on('reload-homepage', () => {
        that.lineItems = []
        that.lineItems = lineItems
      })
    },
    mounted () {
      // sort items by id
      this.lineItems.sort((a, b) => {
        return a.id - b.id
      })
    },
    methods: {
      getIconClass (item) {
        return item.iconClass ? item.iconClass : 'icon-homepage-button-default'
      },
      getText (item) {
        return item.text ? item.text : ''
      },
      getRoute (item) {
        return item.route ? item.route : ''
      },
      getIdService (item) {
        return item.idService ? item.idService : 0
      },
      getIsHidden (item) {
        return item.isHidden ? item.isHidden : false
      },
      getEnabled (item) {
        if (item.right_disable && item.right_disable.right) {
          // Return true if the right has the same state as the disabling state
          return !this.$engine.rights.rightIs(item.right_disable.right, item.right_disable.state)
        }
        return item.enabled ? item.enabled : false
      }
    }
  }
</script>

<style scoped>
.homepage-grid-line-container {
  display: flex;
  margin-left: 1%;
  margin-right: 1%;
}
.items-container {
  width: 100%;
}
.header-content {
  display: table-cell;
  vertical-align: middle;
  font-size: 1.1rem;
  font-weight: bold;
  color: white;
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 1431px) {
  .header-content {
    font-size: 2rem;
  }
}
</style>



// WEBPACK FOOTER //
// homepageGridLine.vue?2dc749b1